import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";

import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import {
  useDataProvider,
  useNotify,
  useRedirect,
  Button,
  Confirm,
} from "react-admin";

import { taskByReference } from "../../../graphql/queries";
import { DeleteIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const handleDelete = async (
  record,
  resource,
  dataProvider,
  setLoading,
  notify,
  redirect,
  basePath,
) => {
  debugger;
  setLoading(true);
  try {
    const tasksResp = await API.graphql(
      graphqlOperation(taskByReference, { reference: record.id }),
    );
    const tasks = tasksResp.data.taskByReference.items;
    debugger;

    if (tasks?.length > 0) {
      const idsToDelete = tasks.map((itm) => itm.id);
      await dataProvider.deleteMany("tasks", { ids: idsToDelete });
    }
    await dataProvider.delete(resource, {
      id: record.id,
      previousData: record,
    });

    notify("Audit deleted successfully", "success");
    redirect(basePath);
  } catch (error) {
    logError("audits:DeepDeleteButton:handleDelete", error, notify);
  }
  setLoading(false);
};

export const DeepDeleteButton = ({
  record,
  resource,
  basePath,
  className,
  ...props
}) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  if (!record) return null;
  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={loading}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title={"Delete Confirmation"}
        content={
          "Are you sure you want to delete this Audit and related Tasks, if any?"
        }
        onConfirm={() =>
          handleDelete(
            record,
            resource,
            dataProvider,
            setLoading,
            notify,
            redirect,
            basePath,
          )
        }
        onClose={handleDialogClose}
      />
    </>
  );
};
